import { pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    "pdfjs-dist/build/pdf.worker.min.mjs",
    import.meta.url
).toString();

export const PDF_DOCUMENT_OPTIONS = {
    standardFontDataUrl: "/pdfjs/standard_fonts/",
};
